<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../../utilities/ArrayUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
/** APIs */
import ValidationCardApi from '../../api/ValidationCardApi'
import FormGroupPresetApi from '../../api/FormGroupPresetApi'
import FormsApi from '../../api/FormsApi'
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
/** UI Components */
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Radio } from 'buefy/dist/components/radio'
import { Select } from 'buefy/dist/components/select'
import { Modal } from 'buefy/dist/components/modal'
import { Loading } from 'buefy/dist/components/loading'

export default {
    name : "FormGroupPresetsView",
    components: {
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-select' : Select,
        'b-modal' : Modal,
        'b-loading' : Loading
    },
	computed : {
		...mapState({
            activeNav : "activeNav",
            profile : "userProfile",
            token : "xOreAuth"
        }),
        selectePresetName(){
            if (this.formGroupPresets) {
                if (this.selectedGroupPreset) {
                    let selected = this.formGroupPresets.filter(preset=>{
                        return preset.groupPresetId==this.selectedGroupPreset
                    });
                    if (selected.length > 0) {
                        return selected[0].groupPresetName
                    }
                }
            }
            return "";
        },
        truncAddToLabel(){
            if (!this.selectedLabel) {
                return ""
            }
            if (this.selectedLabel.groupLabelName.trim().length <= 20) {
                return this.selectedLabel.groupLabelName
            }
            return this.selectedLabel.groupLabelName.trim().substr(0,17)+'..';
        },
        notSelectedForms(){
            if (this.allForms.length > 0) {
                
                if (this.groupPresetLabels.length == 0) {
                    return this.allForms;
                }

                let allSelectedForms = [], unSelected = [];
                
                this.allForms.forEach(aform=>{

                    this.groupPresetLabels.forEach(label=>{

                        if (label.forms.length > 0) {
                            
                            let inLabel = label.forms.filter(lform=>{
                                return lform.formId == aform.formId
                            });
                            
                            if (inLabel.length > 0) {
                                allSelectedForms.push(aform)
                            }
                        }

                    });

                });

                if (allSelectedForms.length == 0) {
                    return this.allForms;
                }

                this.allForms.forEach(aform=>{
                    let selected = allSelectedForms.filter(sform=>{
                        return sform.formId == aform.formId
                    });
                    if (selected.length == 0) {
                        unSelected.push(aform)
                    }
                });

                return unSelected;
            }
        },
        presetNameStr(){
            return this.getSelectedPresetName();
        }
    },
    data(){
        return {
            selectedReportingYear : null,
            reportingYearLov : [],
            formGroupPresets : [],
            selectedGroupPreset : null,
            openAddGroupPreset: false,
            newFormGroupPreset : {
                reportingYear : null,
                groupPresetName : ""
            },
            allForms : [],
            groupPresetLabels : [],
            showAddLabels : false,
            newLabels : [],
            selectedLabel : null,
            showRenamePreset : false,
            renameValuePreset : "",
            showRenameLabel : false,
            labelForEdit : null,
            isLoading : true,
            isFullPage : false,
            loadingGroupFormsPanel : false,
            loadingFormsPanel : false
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        // this.isTokenValid();
        this.getReportingYearLov();
    },
    methods : {
        ...mapMutations({
            clearAppData : "clearAppData",
            setActiveNav : "updateActiveNav"
        }),
        
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                
                            }
                        }
                    }
                } 
            })
            .catch(error=>{
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getReportingYearLov(){
            this.isLoading = true;
            this.reportingYearLov = [];
            this.selectedReportingYear = null;
            
            let staticYrs = AppResourceUtil.getRepYrStaticLov();
            // Default reporting year is current year minus 1; or previous year
            let defaultRepYear = parseInt(this.$moment().format('YYYY'),10) - 1;

            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                let repYearInDb = [];
                if (response.data) {
                    if (!response.data.error) {
                        
                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();

                        if (this.$route.query) {
                            try {
                                if (this.$route.query.reportingYear) {
                                    this.selectedReportingYear = parseInt(this.$route.query.reportingYear,10);
                                }
                            }
                            catch(repYrErr){}
                        }
                        
                        if (!this.selectedReportingYear) {
                            if (repYearInDb > 0) {
                                try {
                                    /* Pre-select the year with data (from DB) */ 
                                    this.selectedReportingYear = repYearInDb[0];
                                }
                                catch(yrErr){}
                            }
                            else {
                                this.selectedReportingYear = defaultRepYear;
                            }
                        }

                        if (this.selectedReportingYear != null) {
                            this.getForms();
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        selectReportingYear(){
            if (this.selectedReportingYear != null) {
                this.formGroupPresets = [];
                this.presetLabels = [];
                this.selectedLabel = null;
                this.selectedGroupPreset = null;

                this.getForms();
            }
        },
        getFormGroupPresets(id){
            this.isLoading = true;
            this.formGroupPresets = [];
            FormGroupPresetApi.get({
                reportingYear : this.selectedReportingYear
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.formGroupPresets = response.data;

                        if (!id) {
                            // On load, preset first item
                            if (this.formGroupPresets.length > 0) {
                                if (this.formGroupPresets[0]) {
                                    this.selectedGroupPreset = this.formGroupPresets[0].groupPresetId;
                                }
                            }

                        }
                        else {
                            
                            // When there's newly-added preset
                            // auto-select it
                            let selected = this.formGroupPresets.filter(preset=>{
                                return preset.groupPresetId == id;
                            });
                            if (selected.length > 0) {
                                this.selectedGroupPreset = selected[0].groupPresetId;
                            }
                        }

                        if (this.selectedGroupPreset!=null) {
                            this.getPresetLabels();
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'FormGroupPreset.get');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'FormGroupPreset.get');
            });
        },
        selectPreset(){  
            if (!this.selectedGroupPreset) {
                return false
            }
            this.selectedLabel = null
            this.getPresetLabels();
        },
        getPresetLabels(){
            this.groupPresetLabels = []
            // Get labels
            FormGroupPresetApi.getGroupLabels({
                groupPresetIdFk : this.selectedGroupPreset
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let presetLabels = response.data;
                        if (presetLabels.length > 0) {
                            presetLabels.forEach(label=>{
                                if (label.forms.length > 0) {
                                    label.forms.forEach(lform=>{
                                        if (!lform.formAccessData) {
                                            this.$set(lform,'formAccessData',null)
                                        }
                                        this.$set(lform,'formAccessData',this.getFormAccessData(lform));
                                        // 
                                        let adata = this.setOtherAccessData(lform);
                                        lform.formAccessDataNameList = adata.list;
                                        lform.formAccessDataStr = adata.str;
                                    });
                                }
                            })
                        }
                        this.groupPresetLabels = presetLabels;
                        this.isLoading = false;
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'FormGroupPreset.getPresetLabels');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'FormGroupPreset.getPresetLabels');
            });
        },

        addPreset(){
            this.openAddGroupPreset = true;
            this.newFormGroupPreset.groupPresetName = "";
        },
        closeAddGroupPreset(){
            this.openAddGroupPreset = false;
        },
        triggerClose(mode){
            switch(mode) {
                case 'add' :
                    this.openAddGroupPreset = false;
                    break;
                case 'rename':
                    this.showRenamePreset = false;
                    break;
                case 'renamelabel':
                    this.showRenameLabel = false;
                    break;
            }
        },
        triggerSubmit(){
            if (!this.selectedReportingYear) {
                return false
            }
            if (this.newFormGroupPreset.groupPresetName.trim().length == 0) {
                return false
            }

            FormGroupPresetApi.add({
                reportingYear: this.selectedReportingYear,
                groupPresetName : this.newFormGroupPreset.groupPresetName,
                createdBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let formGroupPresetId = response.data.formGroupPresetId;
                        this.closeAddGroupPreset();
                        this.getFormGroupPresets(formGroupPresetId);
                    }
                    else {
                        this.promptServerError({response},'FormGroupPreset.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormGroupPreset.add');
            });
        },
        setOtherAccessData(form) {
            if (!form.formAccessData) {
                return false
            }

            let entAccess = [], unitAccess = [];
            if (form.formAccessData.reportingEntities.length > 0) {
                entAccess = form.formAccessData.reportingEntities.map(ent=>{
                    return ent.reportingEntity
                })
            }
            if (form.formAccessData.reportingUnits.length > 0) {
                unitAccess = form.formAccessData.reportingUnits.map(unt=>{
                    return unt.reportingUnit
                })
            }
            
            let list = this.$_.union(entAccess,unitAccess);

            return {
                list,
                str : list.join(",")
            }
        },
        getForms(){
            this.allForms = [];
            // With back-end integration
            FormsApi.getAll({
                reportingYear : this.selectedReportingYear
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let forms = response.data;
                        forms.forEach(form=>{
                            let adata = this.setOtherAccessData(form);
                            // list
                            form.formAccessDataNameList = adata.list;
                            form.formAccessDataStr = adata.str;
                        });
                        this.allForms = forms;
                        // set store data - forms
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'Form.getAll');
                    }
                }
                this.getFormGroupPresets();
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'Form.getAll');
            });
        },
        showAccessList(form) {
            let accessListStr = "";
            if (form.formAccessDataNameList.length > 0) {
                form.formAccessDataNameList.forEach(name=>{
                    accessListStr += '<li style="list-style-type:disc;margin-left:1.75em;">'+name+'</li>';
                });
            }
            this.$dialog.alert({
                title: 'Form access ('+form.formName+')',
                message: '<p><ul>'+accessListStr+'</ul></p>',
                type: 'is-info'
            });
        },
        openAddLabels(){
            this.showAddLabels = true;
            this.newLabels = [];
            this.addLabel();
        },
        addLabel(){
            this.newLabels.push({
                labelName : ""
            });
        },
        removeLabel(idx){
            this.newLabels.splice(idx,1);
        },
        closeAddLabels() {
            let unfillednames = this.newLabels.filter(label=>{
                return label.labelName.trim().length==0
            });
            if (unfillednames.length==this.newLabels.length) {
                this.showAddLabels = false;
            }
            else {
                // Prompt
                this.$dialog.confirm({
                    title: 'Confirmation',
                    message: 'You have unsaved changes. Are you sure you want to close this form?',
                    cancelText: "Continue Editing",
                    confirmText: 'Close Form',
                    type: 'is-danger',
                    onConfirm: () => {
                        this.showAddLabels = false;
                    }
                })
            }
        },
        submitNewLabels(){
            let unfillednames = this.newLabels.filter(label=>{
                return label.labelName.trim().length==0
            });
            if (unfillednames.length > 0) {
                // Prompt
                this.$dialog.alert({
                    title: 'Error',
                    message: 'Please check your input. Labels are required.',
                    type: 'is-danger'
                })
                return false
            }
            let forAdding = [];
            this.newLabels.forEach(label=>{
                forAdding.push({
                    groupPresetIdFk : this.selectedGroupPreset,
                    labelName : label.labelName.trim(),
                    addedBy : this.profile.userId
                })
            })
            // Add labels
            if (forAdding.length > 0) {
                FormGroupPresetApi.addLabels(forAdding)
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            if (response.data.isAdded) {
                                this.showAddLabels = false;
                                this.selectPreset();
                            }
                        }
                        else {
                            this.promptServerError({response},'FormGroupPreset.addPresetLabels');
                        }
                    }
                })
                .catch(error=>{
                    this.promptServerError(error,'FormGroupPreset.addPresetLabels');
                });
            }
        },
        selectLabel(label){
            this.selectedLabel = label; 
        },
        renamePreset(){
            if (!this.selectedGroupPreset) {
                this.$dialog.alert({
                    title: 'Warning',
                    message: 'Please selected a preset.',
                    type: 'is-warning'
                });
                return false
            }

            this.showRenamePreset = true;
            this.renameValuePreset = "";

            let presetSelected =  this.formGroupPresets.filter(preset=>{
                return preset.groupPresetId == this.selectedGroupPreset
            });
            
            try {
                if (presetSelected.length > 0) {
                    this.renameValuePreset = presetSelected[0].groupPresetName;
                }
            } 
            catch(err){}

        },
        confirmDeletePreset(){
            if (!this.selectedGroupPreset) {
                this.$dialog.alert({
                    title: 'Error',
                    message: 'Please select preset to delete.',
                    type: 'is-danger'
                });
                return false
            }
            let presetName = this.getSelectedPresetName();
            // Confirm Action
            this.$dialog.confirm({
                title: 'Confirmation',
                message: 'This will remove <b>'+presetName+'</b> and all its labels. <br/><br/> Removing this will <b>unlink the forms</b> mapped to the labels under this preset. <br/><br/> Are you sure you want to delete '+presetName+'?',
                cancelText: "Don't Delete",
                confirmText: 'Delete',
                type: 'is-danger',
                onConfirm: () => {
                    this.deletePreset()
                }
            });
        },
        getFormAccessData(form){
            if (this.allForms.length > 0) {
                let sform = this.allForms.filter(aform=>{
                    return aform.formId == form.formId
                })
                if (sform.length > 0) {
                    return sform[0].formAccessData;
                }
                return null;
            } 
        },
        addFormToLabel(form){
            if (!this.isAdded(form)) {

                if (!this.selectedLabel) {
                    return false
                }

                if (!form) {
                    return false
                }

                // Update DB
                this.updateFormGroup(form,null,this.selectedLabel.groupLabelId);
            }
            else {
                this.$dialog.alert({
                    title: 'Error',
                    message: 'This form has been added already.',
                    type: 'is-danger'
                });
            }
        },
        isAdded(form) {

            if (this.groupPresetLabels.length == 0) {
                return false
            }

            let added = false;
            this.groupPresetLabels.forEach(label=>{
                if (label.forms.length > 0) {
                    
                    let inLabel = label.forms.filter(lform=>{
                        return lform.formId == form.formId
                    });
                    
                    if (inLabel.length > 0) {
                        added = true;
                    }
                }
            })

            return added; 
        },
        confirmRemoveForm(form,formIdx) {
            // Confirm Action
            this.$dialog.confirm({
                title: 'Confirmation',
                message: 'This will remove <b>'+form.formName+'</b> under <i>'+this.selectedLabel.groupLabelName+'</i>.<br/><br/>Are you sure you want to remove this form?',
                cancelText: "Don't Remove",
                confirmText: 'Remove',
                type: 'is-danger',
                onConfirm: () => {
                    this.updateFormGroup(form,formIdx,null)
                }
            });
        },
        updateFormGroup(form,formIdx,groupLabelIdFk) {
            // Add to DB
            this.loadingGroupFormsPanel = true;
            this.loadingFormsPanel = true;
            
            FormGroupPresetApi.updateFormGroup({
                groupLabelIdFk,
                formId : form.formId,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isUpdated) {
                            // Success
                            if (formIdx==null) {
                                // Add to view
                                this.selectedLabel.forms.push({
                                    formId : form.formId,
                                    formName : form.formName,
                                    groupLabelIdFk :  this.selectedLabel.groupLabelId,
                                    formAccessData : form.formAccessData
                                });
                                this.loadingGroupFormsPanel = false;
                                this.loadingFormsPanel = false;
                            }
                            else {
                                // Remove from view
                                this.selectedLabel.forms.splice(formIdx,1);
                                this.loadingGroupFormsPanel = false;
                                this.loadingFormsPanel = false;
                            }
                        }
                    }
                    else {
                        this.loadingGroupFormsPanel = false;
                        this.loadingFormsPanel = false;
                        this.promptServerError({response},'FormGroupPreset.updateFormGrouping');
                    }
                }
            })
            .catch(error=>{
                this.loadingGroupFormsPanel = false;
                this.loadingFormsPanel = false;
                this.promptServerError(error,'FormGroupPreset.updateFormGrouping');
            });
        },
        closeRenamePreset(){
            this.triggerClose('rename')
        },
        getSelectedPresetName(){
            let presetName = "";
            if (this.selectedGroupPreset) {

                let presetSelected =  this.formGroupPresets.filter(preset=>{
                    return preset.groupPresetId == this.selectedGroupPreset
                });
                
                try {
                    if (presetSelected.length > 0) {
                        presetName = presetSelected[0].groupPresetName;
                    }
                } 
                catch(err){}
            }
            return presetName;
        },
        triggerSave(){
            if (this.renameValuePreset.trim().length == 0) {
                return false
            }

            let isExisting = false;
            this.formGroupPresets.forEach(preset=>{
                if (preset.groupPresetId != this.selectedGroupPreset ) {
                    if (preset.groupPresetName == this.renameValuePreset ) {
                        isExisting = true;
                    }
                }
            });

            if (isExisting) {
                this.$dialog.alert({
                    title: 'Error',
                    message: 'This name is already taken. Please enter a new name instead.',
                    type: 'is-danger'
                });
                return false
            }

            FormGroupPresetApi.rename({
                groupPresetId : this.selectedGroupPreset,
                groupPresetName : this.renameValuePreset
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isUpdated) {
                            this.triggerClose('rename');
                            this.getFormGroupPresets(this.selectedGroupPreset);
                        }
                    }
                    else {
                        this.promptServerError({response},'FormGroupPreset.rename');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormGroupPreset.rename');
            });
        },
        deletePreset(){
            let paramData = {
                groupPresetId : this.selectedGroupPreset,
                groupLabelIdArr : [],
                updatedBy : this.profile.userId
            };
            let res = ArrayUtil.getItemInArray(this.formGroupPresets,'groupPresetId',this.selectedGroupPreset);

            if (this.groupPresetLabels.length > 0) {
                paramData.groupLabelIdArr = this.groupPresetLabels.map(label=>{
                    return label.groupLabelId;
                });
            }

            // Updated forms set groupLabelIdFk = null where groupLabelIdFk in groupLabelIdArr
            // Then delete labels in preset
            // then delete preset

            FormGroupPresetApi.delete(paramData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isDeleted) {
                            this.getFormGroupPresets();
                        }
                    }
                    else {
                        this.promptServerError({response},'FormGroupPreset.delete');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormGroupPreset.delete');
            });
        },
        renameLabel(label,labelIdx){
            this.showRenameLabel = true;

            this.labelForEdit = {
                newLabelName : label.groupLabelName,
                originalLabelName : label.groupLabelName,
                groupLabelId : label.groupLabelId
            };
        },
        closeRenameLabel(){
            this.showRenameLabel = false;
        },
        saveNewLabelName(){
            if (!this.labelForEdit) {
                // Error - Empty
                this.$notification.open({
                    duration: 5000,
                    message: 'Unable to proceed. No label is selected.',
                    position: 'is-bottom-left',
                    type: 'is-danger'
                });
                return false
            }
            if (this.labelForEdit.newLabelName.trim().length==0) {
                // Error - Empty
                this.$notification.open({
                    duration: 5000,
                    message: 'Unable to an save empty label.',
                    position: 'is-bottom-left',
                    type: 'is-danger'
                });
                return false;
            }
            if (this.labelForEdit.newLabelName.trim()==this.labelForEdit.originalLabelName.trim()) {
                // No changes
                this.$notification.open({
                    duration: 5000,
                    message: 'No changes detected.',
                    position: 'is-bottom-left',
                    type: 'is-warning'
                });
                return false
            }
            // Save to db
            FormGroupPresetApi.renameLabel(this.labelForEdit)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isUpdated) {
                            if (this.selectedLabel) {
                                this.selectedLabel = null;
                            }
                            this.getPresetLabels();
                            this.closeRenameLabel();
                        }
                    }
                    else {
                        this.promptServerError({response},'FormGroupPreset.renameLabel');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError({response},'FormGroupPreset.renameLabel');
            });
        },
        confirmDeleteLabel(label,labelIdx){
            // Confirm Action
            let presetName = this.getSelectedPresetName();

            this.$dialog.confirm({
                title: 'Confirmation',
                message: 'This will remove <b>'+label.groupLabelName+'</b> label under <b>'+presetName+'</b>. <br/><br/>Removing this will also <b>unlink the forms</b> mapped under this label.<br/><br/>Are you sure you want to delete '+label.groupLabelName+'?',
                cancelText: "Don't Delete",
                confirmText: 'Delete',
                type: 'is-danger',
                onConfirm: () => {
                    this.deleteLabel(label,labelIdx)
                }
            });
        },
        deleteLabel(label,labelIdx){
            let paramData = {
                updatedBy : this.profile.userId,
                groupLabelIdArr : [ label.groupLabelId ]
            };

            FormGroupPresetApi.deleteLabel(paramData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isDeleted) {
                            if (this.selectedLabel) {
                                this.selectedLabel = null;
                            }
                            this.getPresetLabels();
                        }
                    }
                    else {
                        this.promptServerError({response},'FormGroupPreset.deleteLabel');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormGroupPreset.deleteLabel');
            });
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        }
    }
}
</script>

<template>
    <section>
        <div class="base-box--sidepadded">
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li>
                        <a 
                            v-if="selectedReportingYear"
                            v-bind:href="'#/admin/forms?reportingYear='+selectedReportingYear">Forms</a>
                    </li>
                    <li class="is-active"><a href="#" aria-current="page">Grouping</a></li>
                </ul>
            </nav>
        </div>
        
        <p class="subtitle page-title">Form Group Presets</p>

        <div class="base-box--sidepadded margin-left margin-btm--med">
            <div class="field is-grouped">
                <div class="control">
                    <b-dropdown
                        v-model="selectedReportingYear">
                        <button class="button is-primary is-outlined"
                            type="button"
                            slot="trigger">
                            <template
                                v-if="selectedReportingYear">
                                <strong>Reporting Year ({{selectedReportingYear}})</strong>
                            </template>
                            <template
                                v-else>
                                <strong>Select Reporting Year</strong>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item
                            v-for="(year,yearIdx) in reportingYearLov"
                            v-bind:key="yearIdx"
                            v-bind:value="year"
                            v-on:click="selectReportingYear(year)">
                            <h4>{{year}}</h4>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="control"
                    v-if="formGroupPresets.length > 0">
                    <b-dropdown
                        v-model="selectedGroupPreset">
                        <button class="button is-primary is-outlined"
                            type="button"
                            slot="trigger">
                            <template
                                v-if="selectedGroupPreset">
                                <strong>Group Preset ({{selectePresetName}})</strong>
                            </template>
                            <template
                                v-else>
                                <strong>Select Group Preset</strong>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item
                            v-for="(preset,presetIdx) in formGroupPresets"
                            v-bind:key="presetIdx"
                            v-bind:value="preset.groupPresetId"
                            v-on:click="selectPreset(preset)">
                            <h4>{{preset.groupPresetName}}</h4>
                        </b-dropdown-item>

                    </b-dropdown>
                </div>
                <div class="control"
                    v-if="selectedGroupPreset">
                    <b-dropdown>
                        <button class="button is-light"
                            type="button"
                            slot="trigger">
                            <template>
                                <i class="fas fa-ellipsis-h fa-lg"></i>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item
                            v-on:click="renamePreset">
                            <span class="icon">
                                <span class="fas fa-pen"></span>
                            </span>
                            Rename Preset
                        </b-dropdown-item>

                        <b-dropdown-item
                            v-on:click="confirmDeletePreset">
                            <span class="icon">
                                <span class="fas fa-trash"></span>
                            </span>
                            Delete Preset
                        </b-dropdown-item>

                    </b-dropdown>
                </div>
                <div class="control"
                    v-if="formGroupPresets.length == 0">
                    &nbsp;
                   <a class="button is-info"
                        v-on:click="addPreset">
                        <span class="icon">
                           <span class="fas fa-plus"></span>
                        </span>
                        <span>Add Group Preset</span>
                   </a>
                </div>
            </div>
        </div>

        <section class="base-box--loading"
            v-if="isLoading">
            <b-loading 
                v-bind:is-full-page="isFullPage" 
                v-bind:active.sync="isLoading"
                >
                <b-icon
                    pack="fas"
                    icon="sync-alt"
                    size="is-medium"
                    custom-class="fa-spin">
                </b-icon>
                &nbsp;&nbsp;&nbsp;
                <span class="title is-5">Loading</span>
            </b-loading>
        </section>

        <section class="section no-padd--top app-view"
            v-if="selectedGroupPreset && !isLoading"> 

            <section class="section no-padd--top form-table-section"> 
                <div class="columns">
                    <div class="column is-4">
                        <p class="title is-4">Labels</p>

                        <div class="labels-list">
                            <!-- No labels yet -->
                            <div v-if="groupPresetLabels.length == 0"
                                class="has-text-left">
                                <p class="title is-5">There are no labels added to this preset yet.</p>
                                <p class="subtitle">To start adding labels, click 'Add Labels' or click 
                                    <a v-on:click="openAddLabels">here</a>.</p>

                                <button class="button is-large is-success"
                                    v-on:click="openAddLabels">
                                    <span>
                                        Add Labels
                                    </span>
                                    <!-- <span class="icon">
                                        <i class="fas fa-long-arrow-alt-right"></i>
                                    </span> -->
                                </button>
                            </div>

                            <!-- List of labels -->
                            <ul v-if="groupPresetLabels.length > 0"
                                class="forms-list">
                                <li v-for="(label,labelIdx) in groupPresetLabels"
                                    v-bind:key="labelIdx"
                                    v-bind:class="{'has-blue-bg':selectedLabel && selectedLabel.groupLabelName==label.groupLabelName }">

                                    <div class="field is-grouped">

                                        <div class="control">
                                            <b-dropdown>
                                                <button class="button is-light"
                                                    type="button"
                                                    slot="trigger">
                                                    <b-icon icon="menu-down"></b-icon>
                                                </button>

                                                <b-dropdown-item
                                                    v-on:click="renameLabel(label,labelIdx)">
                                                    <span class="icon">
                                                        <span class="fas fa-pen"></span>
                                                    </span>
                                                    Rename
                                                </b-dropdown-item>

                                                <b-dropdown-item
                                                    v-on:click="confirmDeleteLabel(label,labelIdx)">
                                                    <span class="icon">
                                                        <span class="fas fa-trash"></span>
                                                    </span>
                                                    Delete 
                                                </b-dropdown-item>

                                            </b-dropdown>
                                        </div>

                                        <div class="control preset-label-name"
                                            v-bind:class="{
                                                'has-text-white has-text-weight-semibold': selectedLabel && 
                                                selectedLabel.groupLabelName==label.groupLabelName 
                                            }"
                                            v-on:click="selectLabel(label,labelIdx)">
                                            {{label.groupLabelName}} ({{label.forms.length}})
                                        </div>

                                    </div>

                                </li>
                                <li>
                                    <button class="button is-success"
                                        v-on:click="openAddLabels">
                                        <span>
                                            Add Labels
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </div> 
                    </div>

                    <div class="column border-x"
                        v-if="selectedLabel">

                        <div class="title is-4">
                            Forms under <span class="has-text-primary has-text-weight-semibold">{{selectedLabel.groupLabelName}}</span>
                        </div>

                        <div>
                            <b-loading 
                                v-bind:is-full-page="isFullPage" 
                                v-bind:active.sync="loadingGroupFormsPanel"
                                >
                                <span class="title is-5">Loading ..</span>
                            </b-loading>
                        </div>
                        
                        <!-- Forms added to the group/label -->
                        <div class="form-list-body">
                            <div v-if="selectedLabel.forms.length > 0 && !loadingGroupFormsPanel"
                                class="columns is-mobile is-multiline">

                                <div class="column is-full"
                                    v-for="(form,formIdx) in selectedLabel.forms"
                                    v-bind:key="formIdx">

                                    <div class="box"
                                        style="margin-left:0.5em;margin-right:0.5em;">
                                        <div class="columns">

                                            <div class="column">
                                                <div>
                                                    {{form.formName}}
                                                </div>
                                                <div>
                                                    <div class="tags"
                                                        v-if="form.formAccessData">
                                                        <span class="tag"
                                                            v-for="(access,accessIdx) in form.formAccessData.reportingGroups"
                                                            v-bind:key="accessIdx"
                                                            v-bind:class="access.repGroupTagClass">
                                                            {{access.reportingGroup}}
                                                        </span>
                                                        <a class="tag"
                                                            title="View Reporting Entities/Units"
                                                            v-on:click="showAccessList(form)">
                                                            <i class="fas fa-ellipsis-h fa-lg"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="column has-text-right">
                                                <a class="button is-danger is-outlined"
                                                    v-on:click="confirmRemoveForm(form,formIdx)">
                                                    <span class="icon">
                                                        <i class="fas fa-minus"></i>
                                                    </span>
                                                    <span>Remove</span>
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <!-- Empty state form group labels  -->
                        <div class="box" 
                            v-if="selectedLabel.forms.length == 0">
                            <p
                                class="title is-5">There are no forms added to this group/label.</p>
                            <p class="subtitle">Please select from the list to your right.</p>
                        </div>
                    </div>

                    <div class="column"
                        v-if="selectedLabel">
                        <!-- Form selection -->
                        <p class="title is-4">Select forms to add 
                            <!-- <span class="has-text-weight-semibold">{{selectedLabel.groupLabelName}}</span> -->
                        </p>

                        <div>
                            <b-loading 
                                v-bind:is-full-page="isFullPage" 
                                v-bind:active.sync="loadingFormsPanel"
                                >
                                <span class="title is-5">Loading ..</span>
                            </b-loading>
                        </div>

                        <div class="form-list-body">
                            <div v-if="allForms.length > 0 && !loadingFormsPanel"
                                class="columns is-mobile is-multiline">

                                <div class="column is-full"
                                    v-for="(form,formIdx) in notSelectedForms"
                                    v-bind:key="formIdx">
                                    <div class="box"
                                        v-bind:class="{'greyed-out':isAdded(form)}"
                                        style="margin-left:0.5em;margin-right:0.5em;">
                                        <div class="columns">
                                            <div class="column">
                                                <div>
                                                    {{form.formName}}
                                                </div>
                                                <div>
                                                    <div class="tags">
                                                        <span class="tag"
                                                            v-for="(access,accessIdx) in form.formAccessData.reportingGroups"
                                                            v-bind:key="accessIdx"
                                                            v-bind:class="access.repGroupTagClass">
                                                            {{access.reportingGroup}}
                                                        </span>
                                                        <a class="tag"
                                                            title="View Reporting Entities/Units"
                                                            v-on:click="showAccessList(form)">
                                                            <i class="fas fa-ellipsis-h fa-lg"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="column has-text-right add-to-col"
                                                v-if="!isAdded(form)">
                                                <a class="button is-primary is-outlined"
                                                    v-on:click="addFormToLabel(form)">
                                                    <span class="icon">
                                                        <i class="fas fa-plus"></i>
                                                    </span>
                                                    <span>Add to {{truncAddToLabel}}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Empty state if there's no selected label -->
                    <div class="column has-text-centered"
                        v-if="!selectedLabel">
                        <br /><br /><br /><br /><br /><br />
                        <p class="title is-5">There's no label selected.</p>
                        <p class="subtitle">Please select from the list to your left.</p> 
                    </div>
                </div>
            </section>
            
        </section>

        <section class="section no-padd--top app-view"> 

            <!-- Empty State -->
            <div
                class="has-text-centered empty-state-box empty-state-box--white padd-top--lrg" 
                v-if="!selectedGroupPreset && !isLoading" >

                <!-- Company/Agency can start creating validation card; Ready for Input -->
                <div class="has-text-centered">

                    <p class="title is-5">There's no group preset selected.</p>
                    <p class="subtitle">To start grouping forms, select a preset from the dropdown or <a v-on:click="addPreset">create a preset</a>.</p>
                    
                </div>

            </div>

        </section>

        <!-- Add Preset -->
        <b-modal
            has-modal-card
            v-bind:active.sync="openAddGroupPreset"
            v-on:close="closeAddGroupPreset">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Add Group Preset Name</p>
                </header>
                <section class="modal-card-body">

                    <b-field
                        label="Group Preset Name"
                        expanded>
                        <b-input 
                            v-model="newFormGroupPreset.groupPresetName"
                            type="text"
                            required
                            v-on:keyup.native.13="triggerSubmit"></b-input>
                    </b-field>
                
                </section>
                <footer class="modal-card-foot has-text-left">

                    <a class="button is-white"
                        v-on:click="triggerClose('add')">
                        <span>Cancel</span>
                    </a>
                    
                    <a class="button is-success"
                        v-bind:disabled="newFormGroupPreset.groupPresetName.trim().length < 3"
                        v-on:click="triggerSubmit">
                        <span>Submit</span>
                    </a>
                </footer>
            </div>
        </b-modal>

        <!-- Rename Preset -->
        <b-modal
            has-modal-card
            v-bind:active.sync="showRenamePreset"
            v-on:close="closeRenamePreset">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Rename {{presetNameStr}}</p>
                </header>
                <section class="modal-card-body">

                    <b-field
                        label="New Preset Name"
                        expanded>
                        <b-input 
                            v-model="renameValuePreset"
                            type="text"
                            required
                            v-on:keyup.native.13="triggerSave"></b-input>
                    </b-field>
                
                </section>
                <footer class="modal-card-foot has-text-left">

                    <a class="button is-white"
                        v-on:click="triggerClose('rename')">
                        <span>Cancel</span>
                    </a>
                    
                    <!-- v-bind:disabled="newFormGroupPreset.groupPresetName.trim().length < 3" -->
                    <a class="button is-success"
                        v-on:click="triggerSave">
                        <span>Save</span>
                    </a>
                </footer>
            </div>
        </b-modal>

        <!-- Add Labels -->
        <b-modal
            has-modal-card
            v-bind:can-cancel="false"
            v-bind:active.sync="showAddLabels"
            v-on:close="closeAddLabels">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Add Labels</p>
                </header>

                <section class="modal-card-body">
                    
                    <b-field grouped
                        v-for="(glabel,glabelIdx) in newLabels"
                        v-bind:key="glabelIdx">
                        <p class="control">
                            <button class="button is-light"
                                tabindex="-1"
                                v-on:click="removeLabel(glabelIdx)">
                                <span class="icon">
                                    <i class="fas fa-trash"></i>
                                </span>
                            </button>
                        </p>
                        <b-input 
                            expanded
                            v-model="glabel.labelName"
                            type="text"
                            placeholder="Enter form group name/label"
                            required></b-input>
                    </b-field>

                    <button type="button"
                        class="button is-info is-outlined"
                        v-on:click="addLabel"
                        v-bind:disabled="newLabels.length > 9"
                        style="margin-left:3rem;">
                        Add new label
                    </button>
                
                </section>

                <footer class="modal-card-foot has-text-left">

                    <a class="button is-white"
                        v-on:click="closeAddLabels">
                        <span>Cancel</span>
                    </a>
                    
                    <a class="button is-success"
                        v-on:click="submitNewLabels">
                        <span>Submit</span>
                    </a>

                </footer>
            </div>
        </b-modal>

        <!-- Rename Label -->
        <b-modal
            has-modal-card
            v-bind:active.sync="showRenameLabel"
            v-on:close="closeRenameLabel">
            <div class="modal-card">
                <header class="modal-card-head"
                    v-if="labelForEdit && labelForEdit.originalLabelName">
                    <p class="modal-card-title">Rename {{labelForEdit.originalLabelName}}</p>
                </header>
                <section class="modal-card-body">

                    <b-field
                        label="New Label/Group Name"
                        expanded
                        v-if="labelForEdit">
                        <b-input 
                            v-model="labelForEdit.newLabelName"
                            type="text"
                            required
                            v-on:keyup.native.13="saveNewLabelName"></b-input>
                    </b-field>
                
                </section>
                <footer class="modal-card-foot has-text-left">

                    <a class="button is-white"
                        v-on:click="triggerClose('renamelabel')">
                        <span>Cancel</span>
                    </a>
                    
                    <!-- v-bind:disabled="newFormGroupPreset.groupPresetName.trim().length < 3" -->
                    <a class="button is-success"
                        v-on:click="saveNewLabelName">
                        <span>Save</span>
                    </a>
                </footer>
            </div>
        </b-modal>

    </section>
</template>

<style scoped>
.forms-list li {
    padding-left: 0.875rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    border-bottom:1px solid #f1f1f1;
}
.form-list-body {
    max-height:400px;
    overflow-y:scroll;
    overflow-x:hidden;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
}
.box--empty {
    background-color: #f1f1f1;
}

.preset-label-name {
    margin-top: 0.3em;
}
.preset-label-name:hover {
    cursor: pointer;
}
/* .pointer {
    cursor: pointer;
} */
.border-x {
    border-left: 1px solid #f1f1f1;
    border-right: 1px solid #f1f1f1;
}
.has-blue-bg {
    background-color: #7956d5;
}
.greyed-out {
    background-color: #f3f3f3;
    color: #c3c3c3;
}
</style>


// WEBPACK FOOTER //
// src/views/administration/FormGroupPresetsView.vue